import {useCallback} from 'react'

import {Link} from '@primer/react'
// eslint-disable-next-line no-restricted-imports -- Staff debug commands are applied silently, so a toast is the only feedback surface.
import {useToastContext} from '@github-ui/toast/ToastContext'
import type {StaffDebugCommandFeedback} from '@github-ui/copilot-shared-ui/hooks/use-staff-debug-command-dispatch'

import {composerToastMessage} from '../components/session-logs/ahp/ComposerToastMessage'

/**
 * Reports the outcome of a staff debug slash command as a toast.
 *
 * These commands run entirely on the client and never become turns, so there is
 * no anchored surface for their result. They share the composer toast styling
 * with the tool-permission commands so the two read as one family.
 */
export function useStaffDebugFeedbackToast(): (feedback: StaffDebugCommandFeedback) => void {
  const {addToast} = useToastContext()

  return useCallback(
    ({variant, message, link}: StaffDebugCommandFeedback) => {
      // eslint-disable-next-line @github-ui/dotcom-primer/toast-migration -- Staff debug commands are applied silently, so there is no anchored surface for this feedback.
      addToast({
        type: variant === 'danger' ? 'error' : 'success',
        message: composerToastMessage(
          link ? (
            <>
              {message}{' '}
              <Link href={link.href} target="_blank" rel="noopener noreferrer" inline>
                {link.label}
              </Link>
            </>
          ) : (
            message
          ),
        ),
      })
    },
    [addToast],
  )
}
